import React, {Component} from 'react';
import classNames from 'classnames';
import * as dataService from '../../service/data-info-chart/requestsUtil';
import {MONTHLY_RECOVERY_ACCOUNTS, WHITOUT_INFORMATION} from "../../utils/constants";
import * as cbu from "../../utils/checkBusinessUnit";
import * as formatter from "../../utils/formatters"

var Loader = require('react-loader');

class BootstrapTable extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(MONTHLY_RECOVERY_ACCOUNTS + cbu.checkBusinessUnit(this.props.bu))
      .then((json) => {
        this.setState({data: json, loaded: true});
      });
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    if (this.state.data.length > 0) {
      let rows = this.state.data.map(info => {
        return <tr>
          <td>{info.month}</td>
          <td>{formatter.formatNumber(info.accounts)}</td>
          <td>{formatter.formatNumber(info.amount)}</td>
          <td>{info.percentage}%</td>
        </tr>
      });

      return (
        <Loader top={"90%"} loaded={this.state.loaded}>
          <table className={tableClass}>
            <thead>
            <tr>
              <th></th>
              <th># Cuentas</th>
              <th>$ Monto</th>
              <th>% Porcentaje</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
          </table>
        </Loader>
      );
    } else {
      return (
        <Loader loaded={this.state.loaded} top="50%"><h2
          className="without-avilable-information">{WHITOUT_INFORMATION}</h2>
        </Loader>);
    }

  }
}

export default BootstrapTable;



// WEBPACK FOOTER //
// ./src/components/tables/bootstrapTable.js